import { render, staticRenderFns } from "./VersionCard.vue?vue&type=template&id=2b9bd038&scoped=true"
import script from "./VersionCard.vue?vue&type=script&lang=js"
export * from "./VersionCard.vue?vue&type=script&lang=js"
import style0 from "./VersionCard.vue?vue&type=style&index=0&id=2b9bd038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9bd038",
  null
  
)

export default component.exports